import { IUiSettings, TFilterKey } from "@/interfaces";
import { IDtnAuthorization } from "@/shared/dtnWeather";
import { AccessLevel, IUserProfile } from "@/shared/user";

import { migrateState } from "./migrationSteps";

const CURRENT_VERSION = 4; // ! Update after changing the state structure

export interface IState {
  version: number;
  isLoggedIn: boolean;
  didShowWelcome: boolean;
  loginTimestamp: number;
  dtnAuthorization: IDtnAuthorization;
  selectedVessel: { id: string; name: string } | null;
  settings: IUiSettings;
  user: IUserProfile;
  followedAlarms: Record<string, number[]>;
  fuel: {
    isOpen: boolean;
  };
  alarms: {
    filterKeys: Array<TFilterKey>;
    sortKey: string;
  };
}

export const initialState: IState = {
  version: CURRENT_VERSION,
  isLoggedIn: false,
  didShowWelcome: false,
  loginTimestamp: 0,
  dtnAuthorization: {
    accessToken: "",
    expiration: null,
  },
  selectedVessel: null,
  settings: {
    isSidebarOpen: true,
    isSourceDataName: false,
    isSidebarByVessel: true,
    isDarkThemeOn: true,
    language: "en",
  },
  user: {
    details: {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      position: "",
      type: AccessLevel.Admin,
    },
    assets: {
      vessels: [],
      modules: [],
      dashboards: [],
    },
    settings: {
      darkTheme: false,
      units: "imperial",
      homepageModuleId: 0,
      emailNotifications: false,
      mobileNotifications: false,
      // language: "en",
    },
  },
  followedAlarms: {},
  fuel: {
    isOpen: true,
  },
  alarms: {
    filterKeys: ["inalarm"],
    sortKey: "",
  },
};

export const initialStateCreator = (key: string) => {
  if (!localStorage) return initialState;
  if (!localStorage.getItem(key)) return initialState;

  const persistedState = JSON.parse(localStorage.getItem(key));
  const currentState = migrateState(persistedState, CURRENT_VERSION);

  return currentState;
};
